import { Fragment, useState } from "react";
import { Link } from "react-router-dom";

import Actions from "./components/Actions";
import Header from "../../../../components/ui/ListHeader";
import { Table } from "../../../../components/Functional";
import {
  FETCH_LISTS as fetchLists,
  FETCH_SHARED_LISTS as fetchSharedLists,
} from "../../../../graphql/query/List";

const getEditUrl = (id, typeName) => {
  switch (typeName) {
    case "Artist":
    case "Artist_working":
      return `/artist?status=selectListWorking&listId=${id}`;
    case "Artwork":
    case "Artwork_working":
      return `/artworks?status=selectListWorking&listId=${id}`;
    case "Artwork_Image":
      return `/artworks?status=imageSelectListWorking&imageListId=${id}`;
    case "Artwork_Image_working":
      return `/artworks?status=imageSelectListWorking&listId=${id}`;
    case "Company":
    case "Company_working":
      return `/companies?status=selectListWorking&listId=${id}`;
    case "Contact":
    case "Contact_working":
      return `/contacts?status=selectListWorking&listId=${id}`;
    case "Exhibition":
    case "Exhibition_working":
      return `/exhibition?status=selectListWorking&listId=${id}`;
    case "Instance":
    case "Instance_working":
      return `/instance?status=selectListWorking&listId=${id}`;
    case "Instance_Image":
      return `/instance?status=imageSelectListWorking&imageListId=${id}`;
    case "Instance_Image_working":
      return `/instance?status=imageSelectListWorking&listId=${id}`;
    case "Invoice":
    case "Invoice_working":
      return `/invoice?status=selectListWorking&listId=${id}`;
    case "Image":
      return `/instance?status=imageSelectListWorking&imageListId=${id}`;
    case "Image_working":
      return `/instance?status=imageSelectListWorking&listId=${id}`;
    case "Job":
    case "Job_working":
      return `/jobs?status=selectListWorking&listId=${id}`;
    case "Offer":
    case "Offer_working":
      return `/offer?status=selectListWorking&listId=${id}`;
    case "Reservation":
    case "Reservation_working":
      return `/reservations?status=selectListWorking&listId=${id}`;
    case "WarehouseItem":
    case "WarehouseItem_working":
      return `/warehouse?status=selectListWorking&listId=${id}`;
    default:
      return "#";
  }
};


const ListNameLink = props => {
  const { id, values } = props || {};
  const { type } = values || {};
  const editUrl = getEditUrl(id, type?.name);

  return (
    <Link className="underline hover:no-underline" to={editUrl}>
      {props.label}
    </Link>
  );
};

const List = () => {
  const [activeTab, setActiveTab] = useState("owned");

  const ownedTableProps = {
    variant: "dynamicHeight",
    dataKey: "lists",
    headers: [
      { 
        label: "List Name", 
        name: "name", 
        sortKey: "name", 
        type: "custom",
        component: ListNameLink
      },
      { label: "Records in List", name: "itemsCount", type: "label" },
      { label: "Type", name: "type.name", type: "label" },
      {
        label: "Date / Time Last Updated",
        name: "updatedAt",
        type: "date-time",
      },
      { label: "", name: "action", type: "custom", component: Actions },
    ],
    inputs: [],
    FETCH_QUERY: fetchLists({ type: {}, sharing: true }),
  };

  const sharedTableProps = {
    variant: "dynamicHeight",
    dataKey: "sharedLists",
    headers: [
      { 
        label: "List Name", 
        name: "name", 
        sortKey: "name", 
        type: "custom",
        component: ListNameLink
      },
      { label: "Records in List", name: "itemsCount", type: "label" },
      { label: "Type", name: "type.name", type: "label" },
      { label: "Shared By", name: "sharedBy.meta.name", type: "label" },
      {
        label: "Date / Time Last Updated",
        name: "updatedAt",
        type: "date-time",
      },
      { label: "", name: "action", type: "custom", component: Actions },
    ],
    inputs: [],
    FETCH_QUERY: fetchSharedLists({ type: {}, sharing: true }),
  };

  return (
    <Fragment>
        <Header leftText="Select Lists" />

        {/* Tab Navigation */}
        <div className="mt-4 px-8 border-b border-gray-200">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            <button
              onClick={() => setActiveTab("owned")}
              className={`whitespace-nowrap border-b-2 px-1 py-2 text-sm font-medium ${
                activeTab === "owned"
                  ? "border-primary-500 text-primary-600"
                  : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
              }`}
            >
              My Select Lists
            </button>
            <button
              onClick={() => setActiveTab("shared")}
              className={`whitespace-nowrap border-b-2 px-1 py-2 text-sm font-medium ${
                activeTab === "shared"
                  ? "border-primary-500 text-primary-600"
                  : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
              }`}
            >
              Shared Select Lists
            </button>
          </nav>
        </div>

      <div className="mt-6 w-full">
        {activeTab === "owned" ? (
          <Table key="owned-table" {...ownedTableProps} />
        ) : (
          <Table key="shared-table" {...sharedTableProps} />
        )}
      </div>
    </Fragment>
  );
};

export default List;
